import { QuotePanelCollapse } from 'routes/essential-workspace/components/quote-panel/collapse';
import { QuotePanelModal } from 'routes/essential-workspace/components/quote-panel/modal';
import { useMediaQuery } from 'usehooks-ts';

import './style.scss';
export function QuotePanel() {
  const isDesktop = useMediaQuery('(min-width: 992px)');

  return (
    <aside aria-label="Quote panel" className="ps-lg-2 ps-xl-3 essential-quote-aside-container">
      {isDesktop ? <QuotePanelCollapse /> : <QuotePanelModal />}
    </aside>
  );
}
